import script from "./CardMetodoPago.vue?vue&type=script&setup=true&lang=js"
export * from "./CardMetodoPago.vue?vue&type=script&setup=true&lang=js"

import "./CardMetodoPago.vue?vue&type=style&index=0&id=19b2ff55&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b2ff55"]])

export default __exports__